import ContrastIcon from '@mui/icons-material/Contrast'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import HexagonIcon from '@mui/icons-material/Hexagon'
import LightModeIcon from '@mui/icons-material/LightMode'
import { IconButton, useTheme as useMuiTheme } from '@mui/material'
import { useContext } from 'react'
import { ThemeContext } from 'theme/ThemeContext'

const ToggleThemeNav = () => {
  const { theme, toggleTheme } = useContext(ThemeContext) // Access theme and toggleTheme
  const _muiTheme = useMuiTheme() // Grab MUI theme if you still need styles

  const renderIcon = () => {
    switch (theme) {
      case 'dark':
        return <ContrastIcon sx={{ height: 22, width: 22 }} />
      case 'grayscale':
        return <HexagonIcon sx={{ height: 22, width: 22 }} />
      case 'obxops':
        return <LightModeIcon sx={{ height: 22, width: 22 }} />
      case 'light':
      default:
        return <DarkModeIcon sx={{ height: 22, width: 22 }} />
    }
  }

  return (
    <IconButton
      onClick={toggleTheme}
      sx={{
        p: 0,
        borderRadius: 0,
        minWidth: 32,
        minHeight: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'transform 0.2s ease-in-out',
        '& .MuiSvgIcon-root': {
          color: 'text.primary',
          transition: 'color 0.2s ease-in-out',
        },
        '&:hover': {
          backgroundColor: 'transparent',
          transform: 'scale(1.2)',
          '& .MuiSvgIcon-root': {
            color:
              theme === 'dark'
                ? 'rgb(255, 213, 79)'
                : theme === 'grayscale'
                ? '#E87722'
                : theme === 'obxops'
                ? 'rgb(255, 213, 79)'
                : 'rgb(66, 165, 245)',
          },
        },
      }}
    >
      {renderIcon()}
    </IconButton>
  )
}

export default ToggleThemeNav

// import React, { useContext } from 'react'
// import { IconButton, useTheme } from '@mui/material'
// import LightModeIcon from '@mui/icons-material/LightMode'
// import DarkModeIcon from '@mui/icons-material/DarkMode'
// import { ThemeContext } from '../../../theme'
// const ToggleThemeNav = () => {
//   const { toggleTheme } = useContext(ThemeContext) // Access theme and toggleTheme

//   const theme = useTheme()
//   return (
//     <>
//       {theme.palette.mode === 'dark' ? (
//         <IconButton
//           onClick={toggleTheme}
//           sx={{
//             p: 0,
//             borderRadius: 0,
//             minWidth: 50, // or 60, adjust to taste
//             minHeight: 60,
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//           }}
//         >
//           <LightModeIcon
//             sx={{
//               height: 22,
//               width: 22,
//             }}
//           />
//         </IconButton>
//       ) : (
//         <IconButton
//           onClick={toggleTheme}
//           sx={{
//             p: 0,
//             borderRadius: 0,
//             minWidth: 50, // or 60, adjust to taste
//             minHeight: 60,
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//           }}
//         >
//           <DarkModeIcon
//             sx={{
//               height: 22,
//               width: 22,
//             }}
//           />
//         </IconButton>
//       )}
//     </>
//   )
// }

// export default ToggleThemeNav
